import { createUniversalInputFunction } from 'MODULES/universal-filters/utils/inputUtils';
import { OperatorEnum } from 'MODULES/universal-filters/utils/operators';
import { FilterTypeEnum } from 'SRC/fetch/api/observability';

export type UniversalInputNameFunction = ReturnType<
  typeof createUniversalInputFunction
>;
export interface CommonProps {
  disabled?: boolean;
  required: boolean;
  getUniversalInputName: UniversalInputNameFunction;
}

export type QuickCommonProps = Omit<CommonProps, 'required'>;

export type DefaultSelectedString = string[] | undefined;
export type DefaultSelectedNumber = [OperatorEnum, number][] | undefined;

export const NUMBER_FILTERS = [
  FilterTypeEnum.NUMBER,
  FilterTypeEnum.CURRENCY,
] as const;
export const STRING_FILTERS = [FilterTypeEnum.STRING] as const;

export type StringFilterExpression = {
  type: (typeof STRING_FILTERS)[number];
  operator: OperatorEnum;
  values: string[];
};

export type BooleanFilterExpression = {
  type: typeof FilterTypeEnum.BOOLEAN;
  operator: typeof OperatorEnum.EQUALS;
  values: ['false' | 'true'];
};

export type NumberFilterExpression = {
  type: (typeof NUMBER_FILTERS)[number];
  values: [OperatorEnum, number][];
};

export type FilterExpression =
  | StringFilterExpression
  | NumberFilterExpression
  | BooleanFilterExpression;

export type UniversalFilter = FilterExpression & {
  key?: string;
};

export function isStringUniversalExpression(
  expression: UniversalFilter,
): expression is StringFilterExpression {
  return !!(expression as StringFilterExpression).operator;
}

export function isNumberFilterType(
  type: FilterTypeEnum,
): type is NumberFilterExpression['type'] {
  return NUMBER_FILTERS.includes(type as NumberFilterExpression['type']);
}
export function isNumberFilter(
  filter?:
    | StringFilterExpression
    | NumberFilterExpression
    | BooleanFilterExpression,
): filter is NumberFilterExpression {
  return NUMBER_FILTERS.includes(
    filter?.type as NumberFilterExpression['type'],
  );
}

export function isBooleanFilter(
  filter?:
    | StringFilterExpression
    | NumberFilterExpression
    | BooleanFilterExpression,
): filter is BooleanFilterExpression {
  return filter?.type === FilterTypeEnum.BOOLEAN;
}

export function isNumberFilterValues(
  values: any,
): values is NumberFilterExpression['values'] {
  return (
    Array.isArray(values) &&
    values.length > 0 &&
    values.every((value) => Array.isArray(value))
  );
}
